import { USER_LOGGED_IN, USER_LOGGED_OUT } from "../utils/types";
import api from "../utils/api";

export const userLoggedIn = user => ({
	type: USER_LOGGED_IN,
	user,
});

export const userLoggedOut = () => ({
	type: USER_LOGGED_OUT,
});

export const login = credentials => dispatch =>
	api.user.login(credentials).then(user => {
		localStorage.wikiJWT = user.token;
		dispatch(userLoggedIn(user));
	});

export const logout = () => dispatch => {
	localStorage.removeItem("wikiJWT");
	dispatch(userLoggedOut());
};

export const signup = data => dispatch =>
	api.user.signup(data).then(user => {
		localStorage.wikiJWT = user.token;
		dispatch(userLoggedIn(user));
	});

export const confirm = token => dispatch =>
	api.user.confirm(token).then(user => {
		localStorage.wikiJWT = user.token;
		dispatch(userLoggedIn(user));
	});



// WEBPACK FOOTER //
// ./src/actions/user.js